import { bindDialog } from "../../hooks/use-dialog-state/UseDialogState";
import { BindUICustomizationSettingsDialogReturn, UICustomizationSettingsDialogState } from "./UICustomizationSettingsDialog";

export function bindUICustomizationSettingsDialog(props: UICustomizationSettingsDialogState): BindUICustomizationSettingsDialogReturn {
    return bindDialog(props);
}
